// Phương & Félix => phuong & felix
export const normaliseString = (str: string) =>
  str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const capitalizeFirst = (str: string): string => {
  if (!str) return "";
  return str[0].toUpperCase() + str.slice(1);
};
